import type { VehicleStatus } from "@/types";

export const vehicleStatusMeta: Record<VehicleStatus, { label: string; badge: string; dot: string }> = {
  disponible: {
    label: "Disponible",
    badge: "bg-accent-100 text-accent-900",
    dot: "bg-accent-500",
  },
  no_disponible: {
    label: "No disponible",
    badge: "bg-background-200 text-foreground-600",
    dot: "bg-foreground-400",
  },
  mantenimiento: {
    label: "En mantenimiento",
    badge: "bg-secondary-100 text-secondary-900",
    dot: "bg-secondary-500",
  },
  reservado: {
    label: "Reservado",
    badge: "bg-primary-100 text-primary-800",
    dot: "bg-primary-500",
  },
};

interface StatusBadgeProps {
  status: VehicleStatus;
  className?: string;
}

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const meta = vehicleStatusMeta[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-label font-semibold ${meta.badge} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} aria-hidden="true"></span>
      {meta.label}
    </span>
  );
}